module.exports = __webpack_public_path__ + "img/trieste.d58e7544.jpg";